import type { CartCoupon } from "@jti/magento";
import type { MagentoApiGetCustomerCouponsQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export type GetCustomerCouponsResult = {
  coupons: CartCoupon[];
  canApplyCoupons: boolean;
};

export const getCustomerCouponsEndpoint = (builder: MagentoApiBuilder) => ({
  getCustomerCoupons: builder.query<GetCustomerCouponsResult, string>({
    query: (cartId) => ({
      method: "getCustomerCoupons",
      params: [{ cartId }],
    }),
    transformResponse: (response: MagentoApiGetCustomerCouponsQueryResponse): GetCustomerCouponsResult => ({
      coupons: (response?.cart?.applied_coupons ?? []) as CartCoupon[],
      canApplyCoupons: response?.cart?.can_apply_coupons ?? false,
    }),
    providesTags: [TAGS.COUPONS],
  }),
});
